import React, { Component } from "react";
import OptionsHeader from "../optionsHeader/OptionsHeader";
import OptionsList from "../optionsList/OptionsList";
import styles from "../PricingWrapper.module.scss";
import { Button } from "@material-ui/core";
import SortData from "../../../../utils/SortUtil";
import HasPermissionTo from "../../../../common/HasPermissionTo";
import { ValidatorForm } from "react-material-ui-form-validator";
import { withTranslation } from "react-i18next";
import ValidationRules from "../../../../common/ValidationRules";
import AppliedPricing from "../../../../shared/appliedPricing/AppliedPricing";
import PositiveValue from "../../../../utils/PostiveValue";
import { NOTNULL_OR_NOTUNDEFINED } from "../../../../utils/EmpUtil";
import {
  DISCOUNT,
  GPRS_ERROR_MESSAGE,
  NONE,
} from "../../../../common/Constants";

class OptionDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      optionsData: this.props.optionsData,
      sortDirection: "ASC",
      sortKey: "optionSpec",
    };

    this.handleSubmit = this.handleSubmit.bind(this);
    this.sortOptionsData(this.state.sortKey);
  }

  componentDidMount() {
    this.calculatePrice(this.state.optionsData);
    ValidationRules();
    Array.isArray(this.props.catalogIds) && this.props.catalogIds.length > 1
      ? this.sortOptionsData("year")
      : this.sortOptionsData("optionSpec");
    this.makeCopyOfOptionsData();
  }

  handleSubmit() {
    this.optionsDataCopy = this.state.optionsData;
    this.calculatePrice(this.state.optionsData);
    this.props.updateEditFlag(false);
    this.props.updateOptionsData(this.state.optionsData);
    this.props.updateIndividualEditIndex(-1);
    this.props.updateEnabledIndividualEdit(false);
    if (this.state.sortKey === "recommendedPrice") {
      this.sortOptionsData(this.state.sortKey, true);
    }
  }

  sortOptionsData(sortByCol, fromSubmit = false) {
    // If dealer has just edited prices, re-sort the way things were previously sorted
    let sortDir;
    if (fromSubmit) {
      sortDir = this.state.sortDirection;
    } else {
      // Default to descending if first click of this arrow
      sortDir = "DSC";
      if (sortByCol === this.state.sortKey) {
        sortDir = this.state.sortDirection === "ASC" ? "DSC" : "ASC";
      }
    }

    const that = this;
    SortData(
      sortByCol,
      sortDir,
      "alphanumeric",
      this.state.optionsData,
      function (sortedData) {
        that.setState({
          optionsData: sortedData,
          sortDirection: sortDir,
          sortKey: sortByCol,
        });
      }
    );
  }

  makeCopyOfOptionsData = () => {
    this.optionsDataCopy = JSON.parse(JSON.stringify(this.state.optionsData));
  };

  editRecords() {
    this.props.toggleEditMode();
    this.props.updateEditFlag(true);
  }

  cancelOptionChanges() {
    this.props.toggleEditMode();
    this.props.updateEditFlag(false);
    this.props.updateIndividualEditIndex(-1);
    this.props.updateEnabledIndividualEdit(false);
    this.setState({ optionsData: this.optionsDataCopy });
  }

  updateAdjustmentPrice(adjustmentTextBoxValue, index, dropdownValue) {
    const copy = JSON.parse(JSON.stringify(this.state.optionsData));

    if (NOTNULL_OR_NOTUNDEFINED(adjustmentTextBoxValue)) {
      const dropDownValue = copy[index].optionsAdjType;
      let amount;
      amount = parseFloat(adjustmentTextBoxValue);

      if (adjustmentTextBoxValue === "") {
        copy[index].adj = adjustmentTextBoxValue;
      } else if (amount === 0) {
        copy[index].adj = amount;
      } else if (dropDownValue === DISCOUNT) {
        if (amount > 0) {
          amount = amount * -1;
          copy[index].adj = amount;
        }
      } else {
        copy[index].adj = amount;
      }
    }

    if (NOTNULL_OR_NOTUNDEFINED(dropdownValue)) {
      copy[index].optionsAdjType = dropdownValue;

      if (dropdownValue === NONE) {
        copy[index].adj = 0;
      } else {
        copy[index].adj = copy[index].adj * -1;
      }
    }
    this.setState({ optionsData: copy });
  }

  resetOptionsRow(event, index) {
    const copy = JSON.parse(JSON.stringify(this.state.optionsData));
    copy[index].adj = 0;
    copy[index].optionsAdjType = NONE;
    const rrp = copy[index].rrp;
    const vm = copy[index].vm;
    copy[index].recommendedPrice = parseFloat(rrp) - parseFloat(vm);
    this.props.updateIndividualEditIndex(-1);
    this.setState({ optionsData: copy });
    this.props.updateOptionsData(copy);
  }

  calculatePrice(data) {
    //will need to change variable names (?) when real data is available
    data.forEach((row) => {
      const rrp = row.rrp === null ? 0 : row.rrp;
      const vm = row.vm === null ? 0 : row.vm;
      const adj = row.adj === null ? 0 : PositiveValue(row.adj);

      if (adj === 0) {
        row.optionsAdjType = NONE;
      }

      row.recommendedPrice =
        row.optionsAdjType === NONE
          ? parseFloat(rrp) - parseFloat(vm)
          : row.optionsAdjType === DISCOUNT
          ? parseFloat(rrp) - parseFloat(vm) - parseFloat(adj)
          : parseFloat(rrp) - parseFloat(vm) + parseFloat(adj);
    });

    this.setState({ optionsData: data });
  }

  render() {
    const isFromNscDealerSearch =
      this.props.user &&
      this.props.user.permissions.rolePermissions.hasOwnProperty(
        "currentPriceSubmit"
      ) &&
      this.props.fromNscDealerSearch;
    return this.state.optionsData && this.state.optionsData.length > 0 ? (
      <div>
        <ValidatorForm onSubmit={this.handleSubmit}>
          <>
            <OptionsHeader
              {...this.props}
              sortKey={this.state.sortKey}
              sortDirection={this.state.sortDirection}
              onClick={(key) => this.sortOptionsData(key)}
              editRecords={(e) => this.editRecords(e)}
              cancelChanges={() => this.cancelOptionChanges()}
              isEditEnabled={
                this.props.isEditEnabled || this.props.individualEditEnabled
              }
            />

            <OptionsList
              {...this.props}
              optionsData={this.state.optionsData}
              updateAdjustmentPrice={(
                adjustmentTextBoxEvent,
                index,
                dropdownValue
              ) =>
                this.updateAdjustmentPrice(
                  adjustmentTextBoxEvent,
                  index,
                  dropdownValue
                )
              }
              resetOptionsRow={(e, index) => this.resetOptionsRow(e, index)}
              editChecked={this.props.editChecked}
              rowEditSaved={this.props.rowEditSaved}
              numberOfRows={this.state.optionsData.length}
              rowOptionsEditedCheckbox={this.props.rowOptionsEditedCheckbox}
              isEditEnabled={
                this.props.isEditEnabled || this.props.individualEditEnabled
              }
              newlyReleased={this.props.newlyReleased}
            />

            <div className={styles.actionSection}>
              {this.props.released &&
              !this.props.viewOnlyPricing &&
              !this.props.priceUpdatesAvailable &&
              !this.props.pendingActionExist &&
              !this.props.buttonEnabled ? (
                <div>
                  {this.props.rowEditSaved ? (
                    <div className={styles.appliedPricing}>
                      <AppliedPricing />
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              ) : (
                <HasPermissionTo
                  permissions={this.props.user.permissions.rolePermissions}
                  perform={["vehiclePricing:view"]}
                  render={() => (
                    <Button
                      data-testid="applyOptionsBtn"
                      variant="contained"
                      onClick={(event) => {
                        this.props.savePricing(event);
                      }}
                      className={
                        isFromNscDealerSearch
                          ? styles.disableActionBtn
                          : styles.applyBtn
                      }
                      component="button"
                      disabled={
                        this.props.isEditEnabled ||
                        this.props.user.readOnly ||
                        isFromNscDealerSearch
                      }
                    >
                      <span>{this.props.t("Options.apply")}</span>
                    </Button>
                  )}
                />
              )}
            </div>
          </>
        </ValidatorForm>
      </div>
    ) : this.props.errorMessage === GPRS_ERROR_MESSAGE ? (
      <span className={styles.dataNotFound}>
        {" "}
        {this.props.t("Error.dataNotFoundFromSource")}
      </span>
    ) : (
      <span className={styles.dataNotFound}>
        {" "}
        {this.props.t("Error.dataNotFound")}
      </span>
    );
  }
}

export default withTranslation("emp")(OptionDetails);
